import React, { useState } from "react";
import { Button, Col, Form, Container, Row, Table } from "react-bootstrap";
import { Link, useLoaderData } from "react-router-dom";
import ApiService from "../../helper/api";
import AlertService from "../../helper/alertService";
// import ChainConfigForm from "./ChainConfigForm";
import Header from "../../componets/Header";
import { FaCircleArrowLeft } from "react-icons/fa6";
import { IoAddCircleSharp } from "react-icons/io5";
import { FaEye, FaEyeSlash, FaCopy } from "react-icons/fa";

function Componet(props) {
	const { chainConfig } = useLoaderData();
	const [isDisabledFields, setIsDisabledFields] = useState(false);
	const [_chainConfig, _setChainConfig] = useState(false);
	const [showApiKey, setShowApiKey] = useState(false);
	const [copied, setCopied] = useState(false);

	const getChainConfigById = chainId => {
		if (!chainId) {
			return false;
		}
		setIsDisabledFields(true);
		ApiService.getChainConfigById(chainId)
			.then(response => {
				if (response && response.data) {
					_setChainConfig(response.data);
				}
			})
			.catch(error => AlertService.alert("error", error))
			.finally(() => {
				setIsDisabledFields(false);
			});
	};

	const handleCopy = async value => {
		try {
			await navigator.clipboard.writeText(value);
			setCopied(true);
			setTimeout(() => setCopied(false), 1500);
		} catch (e) {
			console.error("Copy failed");
		}
	};

	const closeModal = () => {
		_setChainConfig(null);
	};
	const scannerTypeMap = {
		1: "Etherscan",
		2: "Blockscout",
	};

	const platformTypeMap = {
		1: "EVM",
		2: "Non-EVM",
	};

	return (
		<div className="py-3">
			<Container>
				<Header>
					<div className="d-flex justify-content-between w-100">
						<div className="d-flex gap-2 align-items-center">
							<Link to="/network-platforms">
								<FaCircleArrowLeft size={20} />
							</Link>
							<h4 className="mb-0 ">{chainConfig.chainName} Chain</h4>
						</div>
						{/* <Button
							variant="primary"
							size="sm"
							className="px-4"
							disabled={isDisabledFields}
							onClick={() => {
								getChainConfigById(chainConfig.id);
							}}>
							Edit
						</Button> */}
					</div>
				</Header>
				{/* ===== HEADER ===== */}
				{/* <div className="mb-4">
					<div className="d-flex justify-content-between align-items-center bg-white p-3 rounded shadow-sm">
						<div className="d-flex align-items-center gap-2">
							<Link to="/network-platforms" className="text-dark">
								<FaCircleArrowLeft size={22} />
							</Link>
							<h4 className="mb-0 fw-semibold">
								{chainConfig?.chainName || "Chain"} Chain
							</h4>
						</div>

						<Button
							variant="outline-primary"
							size="sm"
							className="px-4"
							disabled={isDisabledFields}
							onClick={() => getChainConfigById(chainConfig.id)}>
							Edit
						</Button>
					</div>
				</div> */}

				{/* ===== CONTENT ===== */}
				{chainConfig ? (
					<Row className="gy-4">
						{/* ===== INFO CARD ===== */}
						<Col md={12}>
							<div className="bg-white rounded shadow-sm p-4">
								{/* Name */}
								<div className="mb-3 d-flex align-items-center">
									<strong className="me-2">Name:</strong>
									<span className="text-success fw-semibold">
										{chainConfig.chainName} ({chainConfig.chainSlug})
									</span>
									<img
										src={chainConfig.chainLogo}
										className="ms-2"
										style={{ width: 22, height: 22, objectFit: "contain" }}
										alt="logo"
									/>
								</div>

								{/* IDs */}
								<div className="mb-2">
									<strong>ChainList ID:</strong>{" "}
									<span
										className={
											chainConfig.chainId ? "text-success" : "text-danger"
										}>
										{chainConfig.chainId || "..."}
									</span>
								</div>

								<div className="mb-2 text-muted small">
									<strong>Internal ID:</strong> #{chainConfig.id}
								</div>

								{/* Status */}
								<div className="mb-2">
									<strong>Status:</strong>{" "}
									<span
										className={
											chainConfig.isActive
												? "badge bg-success"
												: "badge bg-danger"
										}>
										{chainConfig.isActive ? "Active" : "Inactive"}
									</span>
								</div>

								{/* Platform */}
								<div className="mb-2">
									<strong>Platform:</strong>{" "}
									<span className="text-success">
										{chainConfig.platformName}
									</span>{" "}
									<span className="badge bg-secondary ms-2">
										{platformTypeMap[chainConfig.platformType] || "Unknown"}
									</span>
								</div>

								{/* Scanner */}
								<div className="mb-2">
									<strong>Scanner:</strong>{" "}
									<span className="badge bg-info">
										{scannerTypeMap[chainConfig.scannerType] || "Unknown"}
									</span>
								</div>

								{/* Decimals */}
								<div className="mb-2">
									<strong>Decimals:</strong>{" "}
									<span className="text-success">{chainConfig.decimals}</span>
								</div>

								{/* Currency */}
								<div className="mb-2 d-flex align-items-center">
									<strong className="me-2">Currency:</strong>
									<span className="text-success fw-semibold">
										{chainConfig.currencySlug}
									</span>
									<img
										src={chainConfig.currencyLogo}
										className="ms-2"
										style={{ width: 20, height: 20, objectFit: "contain" }}
										alt="logo"
									/>
								</div>

								<hr />

								{/* API URL */}
								<div className="mb-2">
									<strong>API URL:</strong>{" "}
									<a
										href={chainConfig.apiUrl.trim()}
										target="_blank"
										rel="noreferrer"
										className="text-decoration-none">
										<span className="max-line-1" title={chainConfig.apiUrl}>
											{chainConfig.apiUrl}
										</span>
									</a>
								</div>

								{/* API KEY */}
								{/* <div className="mb-2">
									<strong>API Key:</strong>{" "}
									<code className="text-muted">
										****{chainConfig.apiKey?.slice(-4)}
									</code>
								</div> */}
								{chainConfig.apiKey && (
									<div className="mb-2">
										<label className="form-label fw-semibold mb-2">
											API Key
										</label>

										<div className="d-flex align-items-center border rounded px-3 py-2">
											<span
												className="flex-grow-1 max-line-1"
												title={chainConfig.apiKey}>
												{showApiKey ? chainConfig.apiKey : "•".repeat(20)}
											</span>

											<div className="d-flex gap-3 ms-3">
												<span
													role="button"
													title={showApiKey ? "Hide" : "Show"}
													className="text-secondary"
													onClick={() => setShowApiKey(prev => !prev)}>
													{showApiKey ? <FaEyeSlash /> : <FaEye />}
												</span>

												<span
													role="button"
													title="Copy"
													className="text-secondary"
													onClick={() => handleCopy(chainConfig.apiKey)}>
													<FaCopy />
												</span>
											</div>
										</div>

										{copied && (
											<div className="text-success small mt-1">Copied ✔</div>
										)}
									</div>
								)}

								{/* Tokens Count */}
								<div className="mb-2">
									<strong>Tokens:</strong>{" "}
									<span className="badge bg-dark">
										{chainConfig.tokens?.length || 0}
									</span>
								</div>
							</div>
						</Col>

						{/* ===== CONTRACTS ===== */}
						<Col md={12}>
							<div className="bg-white rounded shadow-sm p-4">
								{/* <div className="d-flex justify-content-between align-items-center mb-3">
									<h6 className="mb-0 fw-semibold">Contracts</h6>

									<Button
										variant="success"
										size="sm"
										className="d-flex align-items-center gap-1">
										<IoAddCircleSharp size={18} />
										Add
									</Button>
								</div> */}

								{chainConfig.tokens && chainConfig.tokens.length > 0 ? (
									<Table responsive hover bordered className="align-middle">
										<thead className="table-light">
											<tr>
												<th>#</th>
												<th>Token</th>
												<th>Contract</th>
												<th>Decimals</th>
												<th>ABI</th>
												{/* <th className="text-end">Actions</th> */}
											</tr>
										</thead>
										<tbody>
											{chainConfig.tokens.map((item, index) => (
												<tr key={index}>
													<td className="text-muted">{index + 1}</td>

													<td>
														<div className="d-flex align-items-center gap-2">
															<img
																src={item.logo}
																style={{ width: 20, height: 20 }}
																alt="logo"
															/>
															<span className="max-line-1">
																{item.slug} ({item.name})
															</span>
														</div>
													</td>

													<td>
														<span
															className="max-line-1"
															title={item.contractAddress}>
															{item.contractAddress}
														</span>
													</td>

													<td>{item.decimals}</td>

													<td>
														<span className="max-line-1" title={item.abi}>
															{item.abi}
														</span>
													</td>

													{/* <td className="text-end">
														<div className="d-flex justify-content-end gap-2">
															<Button size="sm" variant="outline-primary">
																Edit
															</Button>
															<Button size="sm" variant="outline-danger">
																Delete
															</Button>
														</div>
													</td> */}
												</tr>
											))}
										</tbody>
									</Table>
								) : (
									<p className="text-muted mb-0">No contracts</p>
								)}
							</div>
						</Col>
					</Row>
				) : (
					<div className="text-center py-5">
						<h5 className="text-muted">No Data</h5>
					</div>
				)}
			</Container>
			{/* <ChainConfigForm closeModal={closeModal} chainConfig={_chainConfig} /> */}
		</div>
	);
}

const loader = async ({ _, params: { chainId } }) => {
	try {
		const chainConfig = await ApiService.getChainConfig(+chainId)
			.then(response => {
				if (response.data) {
					return response.data;
				} else {
					return null;
				}
			})
			.catch(error => {
				AlertService.alert("error", error);
			});

		return { chainConfig };
	} catch (error) {
		AlertService.alert("error", error);
		return error;
	}
};
const ChainConfigView = Object.assign(Componet, { loader });
export default ChainConfigView;
